<template>
  <section>
    <div class="container pt-lg-md" style="overflow-y: scroll;padding-bottom: 60px;">
      <div class="row">
        <div class="col">
          <h1 class="heading">
            Welcome <span style="font-weight: 600;">{{ usersName }}</span>
          </h1>
        </div>
      </div>
      <!-- <div class="row" style="">
        <div class="col-sm-6">
          <card>
            <round-icon name="fa fa-plus-square-o" type="success"></round-icon>
        
          </card>
        </div>
        <div class="col-sm-6">
          <card>
            <round-icon name="fa fa-plus-square-o" type="success"></round-icon>
          </card>
        </div>
      </div> -->
      <div class="row" v-if="invites.length">
        <div class="col-sm" v-for="inv of invites" :key="inv.LoanAppGUID">
          <base-alert
            type="secondary"
            style="display: flex;justify-content: space-between;align-items: center;"
          >
            <div>
              <span class="alert-inner--icon text-success"
                ><i class="ni ni-bell-55"></i
              ></span>
              <span class="alert-inner--text"
                ><strong class="text-primary">New! </strong> You have been
                requested as a co-borrower for {{ inv.user.FirstName }}
                {{ inv.user.LastName }}</span
              >
            </div>

            <div>
              <div
                class="btn btn-link btn-sm text-success"
                @click="inviteRespond(inv.LoanAppGUID, 'Accepted')"
              >
                Accept
              </div>
              <div
                class="btn btn-link btn-sm text-danger"
                @click="inviteRespond(inv.LoanAppGUID, 'Declined')"
              >
                Decline
              </div>
            </div>
          </base-alert>
        </div>
      </div>
      <div
        class="row"
        style="margin-bottom: 1rem;"
        v-if="apps.length || secApps.length"
      >
        <div class="col-sm">
          <card>
            <h2 class="heading">Loan Application(s)</h2>
            <div class="applications" v-if="apps.length">
              <div
                class="app"
                @click="goToApp(app)"
                v-for="app of apps"
                :key="app.LoanAppGUID"
              >
                <div
                  class="icon icon-shape mb-4 icon-shape-success rounded-circle"
                  :style="{ background: iconColorLight }"
                >
                  <i
                    :style="{ color: iconColor }"
                    class="ni ni-single-copy-04"
                  ></i>
                </div>
                <div style="width: 100%;">
                  <div class="default">
                    <div class="type">
                      {{ app.Type }}
                      <i
                        v-if="app.Submitted"
                        class="fa fa-check-circle"
                        aria-hidden="true"
                        style="font-size: 18px;color: #2dce89;font-weight: bold;"
                      ></i>
                    </div>
                    <div class="data">{{ app.Date }}</div>
                  </div>
                  <base-progress
                    v-if="app.Progress"
                    style="padding-top: 6px;"
                    type="success"
                    :value="app.Progress.total"
                  ></base-progress>
                </div>
              </div>
            </div>
            <div class="applications" v-if="secApps.length">
              <div
                class="app"
                @click="goToApp(app)"
                v-for="app of secApps"
                :key="app.LoanAppGUID"
              >
                <div
                  class="icon icon-shape mb-4 icon-shape-success rounded-circle"
                  :style="{ background: iconColorLight }"
                >
                  <i
                    :style="{ color: iconColor }"
                    class="ni ni-single-copy-04"
                  ></i>
                </div>
                <div style="width: 100%;">
                  <div class="default">
                    <div class="type">
                      {{ app.FirstName }} {{ app.LastName }}'s {{ app.Type }}
                    </div>
                    <div class="data">{{ app.Date }}</div>
                  </div>
                  <base-progress
                    v-if="app.Progress"
                    style="padding-top: 6px;"
                    type="success"
                    :value="app.Progress.total"
                  ></base-progress>
                </div>
              </div>
            </div>
          </card>
        </div>
        <!-- <div class="col-sm">
          <card shadow>
            <h2 class="heading">Agent</h2>
            <div class="agents">
              <div style="text-align: center;color: #adb5bd;padding: 1rem;">
                There is not an agent assigned to you yet.
              </div>
            </div>
          </card>
        </div> -->
      </div>
      <div class="row" style="margin-bottom: 4rem;">
        <div class="col-sm">
          <card>
            <!-- <h2 class="heading">Get Started</h2> -->
            <div
              class="applications"
              v-if="!hide"
              style="display: flex;flex-direction: column;justify-content: flex-start;"
            >
              <!-- <base-button
                style="margin:2rem 0 1rem;"
                type="primary"
                @click="newPreApp"
                >Get Pre-Approved</base-button
              > -->
              <base-button style="margin:2rem 0" type="success" @click="newApp"
                >Start new application</base-button
              >
            </div>
          </card>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  getAllApplications,
  checkForInvites,
  respondToInvite,
} from "../services/application";
import { success, warning } from "../services/message";
export default {
  name: "mainPage",
  data() {
    return {
      apps: [],
      secApps: [],
      hide: true,
      invites: [],
      usersName: "",
      iconColor: this.$theme.success,
      iconColorLight: this.$theme.successLight,
    };
  },
  created() {
    this.usersName = window.sessionStorage.getItem("name");
    this.getApps();
    this.getCoBorrowerInvites();
    window.addEventListener("theme", () => {
      (this.iconColor = this.$theme.success),
        (this.iconColorLight = this.$theme.successLight);
    });
  },
  methods: {
    newPreApp() {
      this.$router.push("/pre-approval");
    },
    newApp() {
      this.$router.push("/application/new/agreements");
    },
    async getApps() {
      let res = await getAllApplications();
      if (res.status == 200 && res.primary) {
        this.apps = await this.overallPercent(res.primary);
        this.secApps = await this.overallPercent(res.secondary);
      }
      this.hide = false;
    },
    async inviteRespond(id, status) {
      try {
        await respondToInvite(id, status);
        success(`Invitation ${status}`);
        this.invites = this.invites.filter((i) => {
          if (i.LoanAppGUID !== id) return i;
        });
        this.getApps();
      } catch (error) {
        warning(error.message);
      }
    },
    async getCoBorrowerInvites() {
      try {
        let res = await checkForInvites();
        if (res.status == 200) {
          this.invites = res.invites;
        }
      } catch (error) {
        warning(error.message);
      }
    },
    overallPercent(apps) {
      for (let i = 0; i < apps.length; i++) {
        const app = apps[i];
        let sum = 0;
        let possible = 0;
        if (app.Progress) {
          for (const key in app.Progress.sections) {
            sum += app.Progress.sections[key].progress;
            possible++;
          }
          app.Progress.total = Math.round(sum / possible);
        } else {
          app.Progress = { total: 0 };
        }
      }
      return apps;
    },
    goToApp(app) {
      if (app.OfficerNeedsSelected) {
        this.$router.push({
          name: "officer",
          params: { id: app.LoanAppGUID },
        });
        return
      }

      if (app.Progress.total === 0) {
        this.$router.push({
          name: "agreements",
          params: { id: app.LoanAppGUID },
        });
      } else {
        this.$router.push({
          name: "main-application",
          params: { id: app.LoanAppGUID },
        });
      }
    },
  },
};
</script>
<style lang="scss">
.applications {
  width: 100%;
  .app {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    padding: 1rem 1rem;
    border-radius: 4px;
    margin: 0 -1rem;

    cursor: pointer;
    .icon {
      margin-right: 1rem;
      width: 50px;
    }
    .default {
      display: flex;
      justify-content: space-between;
    }
    &:hover {
      background-color: #f6f7f8;
    }
  }
}
</style>
